"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoneySchema = void 0;
const zod_1 = require("zod");
const __1 = require("..");
exports.MoneySchema = zod_1.z.object({
    amount: zod_1.z.number(),
    currency: zod_1.z.nativeEnum(__1.Currency),
});
//# sourceMappingURL=money.js.map